import { UseFormRegister, FieldErrors, Control } from 'react-hook-form';

export type BusinessType = 'General' | 'Agency' | 'School' | 'University' | 'Government' | 'Museum';

export const BUSINESS_TYPE_MAP: Record<BusinessType, string> = {
  General: '일반 기업',
  Agency: '이벤트광고대행사',
  School: '초중고등학교',
  University: '대학교대학원',
  Government: '공공기관지자체비영리단체',
  Museum: '도서관과학관박물관'
};

export const getBusinessTypeKorean = (businessType: BusinessType | ''): string => {
  if (!businessType) return '';
  return BUSINESS_TYPE_MAP[businessType] || businessType;
};

export type PaymentMethod = 'Card' | 'Transfer';

export interface FormData {
  organizationName: string;
  contactName: string;
  jobTitle: string;
  phone: string;
  email: string;
  businessType: BusinessType | '';
  contentPurpose: string;
  operationStartDate: string;
  operationEndDate: string;
  useMonths: number;
  paymentMethod: PaymentMethod | '';
  contactAvailableTime: string;
  inquiryContent: string;
  personalInfoConsent: boolean;
}

export interface ContactFormProps {
  control: Control<FormData>;
  register: UseFormRegister<FormData>;
  errors?: FieldErrors<FormData>;
}

export interface PrivacyAgreementProps {
  register: UseFormRegister<FormData>;
  error?: string;
}
